export default __webpack_public_path__ + "static/media/lajolla.4220a958.JPG";